import {
  changeDocumentFieldsMeta,
  changeEmbedDocumentFieldsMeta,
  createDocumentField,
  createEmbedDocumentField,
  deleteDocumentField,
  deleteEmbedDocumentField,
  pushToDocumentFieldsHistory,
  pushToEmbedDocumentFieldsHistory,
  redoDocumentFieldsHistory,
  redoEmbedDocumentFieldsHistory,
  setDocumentFields,
  undoDocumentFieldsHistory,
  undoEmbedDocumentFieldsHistory,
  updateDocumentField,
  updateDocumentFieldLocally,
  updateEmbedDocumentField,
} from './actionCreators';
import reducer from './reducer';
import sagas from './sagas';

export default {
  sagas,
  reducer,
  actions: {
    setDocumentFields,
    createDocumentField,
    updateDocumentField,
    updateDocumentFieldLocally,
    deleteDocumentField,
    changeDocumentFieldsMeta,
    pushToDocumentFieldsHistory,
    undoDocumentFieldsHistory,
    redoDocumentFieldsHistory,
    createEmbedDocumentField,
    updateEmbedDocumentField,
    deleteEmbedDocumentField,
    changeEmbedDocumentFieldsMeta,
    pushToEmbedDocumentFieldsHistory,
    undoEmbedDocumentFieldsHistory,
    redoEmbedDocumentFieldsHistory,
  },
};

export const $actions = {
  setDocumentFields,
};
